import { render, staticRenderFns } from "./AddPolygonsFromFile.vue?vue&type=template&id=122f3da1"
import script from "./AddPolygonsFromFile.vue?vue&type=script&lang=ts"
export * from "./AddPolygonsFromFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports